import React from 'react';
import Select from 'react-select';
import BaseApi from '../../api/BaseApi.js';
import ScreenCaption from '../screen-caption.js';


export default class BeneficiaryScreen extends React.Component {

    constructor(props) {
        
        super(props);

        const readonly = props.args.caller == "event-participant"

        this.state = {
                        isDraft: false,
                        saved: false,
                        disabled: readonly,
                        instituteOptions: [], 
                        role: sessionStorage.getItem("role"),
                        currentBeneficiary: {id: null, 
                                        firstname: "",
                                        surname: "", 
                                        sex: null,
                                        sexLabel: "",
                                        birthdate: null, 
                                        yearofbirth: null,
                                        institutionid: this.props.args.callargs.instituteid,
                                        institution: ""},
                        validation: {
                            isValid: true,
                            firstname: true,
                            surname: true,
                            sex: true,
                            institution: true
                        }
                    };

        this.handleChangeFirstname = this.handleChangeFirstname.bind(this);  
        this.handleChangeSurname = this.handleChangeSurname.bind(this);  
        this.handleChangeSex = this.handleChangeSex.bind(this); 
        this.handleChangeBirthdate = this.handleChangeBirthdate.bind(this);  
        this.handleChangeYearOfBirth = this.handleChangeYearOfBirth.bind(this);  
        this.handleChangeInstitution = this.handleChangeInstitution.bind(this); 
        this.save = this.save.bind(this);                         
    }

    timerId = null;

    async componentDidMount() {

        if (this.props.args.beneficiary && this.props.args.beneficiary.length > 0) {
            BaseApi.get("/beneficiary", {headers: {
                'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, params: {id: this.props.args.beneficiary}, withCredentials: true})
            .then(res => {
                var beneficiary = res.data

                switch(beneficiary.sex) {
                    case 1: beneficiary.sexLabel = "Мужской";
                    break;
                    case 2: beneficiary.sexLabel = "Женский";
                    break;
                    default: beneficiary.sexLabel = "Не указано";
                }

                this.setState({currentBeneficiary: beneficiary})
            })    
            .catch()
        } else {
            this.validate()
            this.setState({isDraft: true})
        } 

        BaseApi.get("/institutions", {headers: {
            'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, params: {list: true}, withCredentials: true})
        .then(res => {
            const instituteOptions = res.data.map(({id, name}) => ({value: id, label: name}))
            this.setState({instituteOptions: instituteOptions})
        })    
        .catch()
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevState.currentBeneficiary != this.state.currentBeneficiary) {
            this.validate()
        }
    }


    save(event) {
        BaseApi.post('/beneficiary', this.state.currentBeneficiary, {headers: {
            'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            var currentBeneficiary = this.state.currentBeneficiary
            currentBeneficiary.id = res.data.id
            this.setState({currentBeneficiary: currentBeneficiary, isDraft: false, saved: true})
            this.props.args.beneficiary = res.data.id

            if (this.timerId) {
                clearTimeout(this.timerId);
            }

            this.timerId = setTimeout(() => {
                this.setState({ saved: false });
                this.timerId = null;
            }, 1000);
        })
        .catch(error=>console.log(error))
        
        event.preventDefault();
    }

    delete() {
        BaseApi.delete('/beneficiary', {headers: {
            'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, 
            params: {id: this.state.currentBeneficiary.id},
            withCredentials: true})
        .then(res => {
            this.props.goback(this.props.args)
        })
        .catch(error=>console.log(error))
    }

    validate() {
        const beneficiary = this.state.currentBeneficiary
        const firstname =  beneficiary.firstname.length > 0
        const surname = beneficiary.surname.length > 0
        const sex = beneficiary.sexLabel.length > 0
        const institution =  beneficiary.institutionid !== undefined &&  beneficiary.institutionid.length > 0
    
        this.setState({
            validation: {
                isValid: firstname && surname && sex && institution,
                firstname: firstname,
                surname: surname,
                sex: sex,
                institution: institution    
            }
        })
    }

    handleChangeFirstname(event) {
        this.setState( prevSrtate => ({
            currentBeneficiary: {
                ...prevSrtate.currentBeneficiary,
                firstname: event.target.value
            },
            isDraft: true

        }))
    }
    handleChangeSurname(event) {
        this.setState( prevSrtate => ({
            currentBeneficiary: {
                ...prevSrtate.currentBeneficiary,
                surname: event.target.value
            },
            isDraft: true

        }))
    }

    handleChangeSex(selectedOption) {
        this.setState( prevSrtate => ({
            currentBeneficiary: {
                ...prevSrtate.currentBeneficiary,
                sex: selectedOption.value,
                sexLabel: selectedOption.label
            },
            isDraft: true
        }))
    }

    handleChangeBirthdate(event) {
        var currentBeneficiary = this.state.currentBeneficiary
        currentBeneficiary.birthdate = event.target.value
        this.setState({currentBeneficiary: currentBeneficiary})
    }


    handleChangeYearOfBirth(event) {
        this.setState( prevSrtate => ({
            currentBeneficiary: {
                ...prevSrtate.currentBeneficiary,
                yearofbirth: event.target.value
            },
            isDraft: true

        }))
    }

    handleChangeInstitution(selectedOption) {
        this.setState( prevSrtate => ({
            currentBeneficiary: {
                ...prevSrtate.currentBeneficiary,
                institutionid: selectedOption.value,
                institution: selectedOption.label
            },
            isDraft: true

        }))
    }

    openEvents() {
        this.props.navigate("events", 
        {caller: "beneficiary", callargs: this.props.args, beneficiary: this.state.currentBeneficiary.id})

    }

    openRefs() {
        this.props.navigate("refs", 
        {caller: "beneficiary", callargs: this.props.args, refrecid: this.state.currentBeneficiary.id})    
    }

    render() {
    
        const institutionPrenests = this.props.args.callargs.instituteid === undefined;
        return (

        

            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.props.args} caption={"Участник"}/>

                <div class="row mt-4">
                    <div class="col-lg-8">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">
                                    {this.state.currentBeneficiary.id ? "Редактирование участника" : "Новый участник"}
                                </h6>
                                {this.state.isDraft &&
                                    <span className="badge text-bg-warning">
                                        Имеются несохранённые данные
                                    </span>
                                }
                                <form>
                                    <div class="form-group">
                                        <label 
                                            for="name"
                                            className={`form-label ${this.state.validation.firstname ? "" : "text-danger"}`}
                                        >
                                            Имя:
                                        </label>
                                        <input 
                                            type="text" 
                                            className={`form-control ${this.state.validation.firstname ? "" : "text-danger"}`}
                                            id="name" 
                                            disabled={this.state.disabled}
                                            value={this.state.currentBeneficiary.firstname} 
                                            onChange={this.handleChangeFirstname} 
                                        />
                                        <label 
                                            for="surname"
                                            className={`form-label ${this.state.validation.surname ? "" : "text-danger"}`}
                                        >
                                            Фамилия:
                                        </label>
                                        <input 
                                            type="text" 
                                            className={`form-control ${this.state.validation.surname ? "" : "text-danger"}`}
                                            id="surname" 
                                            value={this.state.currentBeneficiary.surname} 
                                            onChange={this.handleChangeSurname} 
                                            disabled={this.state.disabled}
                                        />
                                        <label 
                                            for="sex"
                                            className={`form-label ${this.state.validation.sex ? "" : "text-danger"}`}
                                        >
                                            Пол:
                                        </label>
                                        <div
                                            className={
                                                this.state.validation.sex
                                                ? "" : "border border-danger rounded"
                                            }
                                        >
                                            <Select options={[{value: 1, label: "Мужской"}, {value: 2, label: "Женский"}]} 
                                                    id="sex" 
                                                    onChange={this.handleChangeSex}
                                                    placeholder={this.state.currentBeneficiary.sexLabel} 
                                                    isDisabled={this.state.disabled}     
                                                    />
                                        </div>        
                                        <label for="birthdate">Год рождения:</label>
                                        <input 
                                            type="number" 
                                            min="2000" 
                                            max="2025" 
                                            class="form-control" 
                                            id="birthdate"  
                                            value={this.state.currentBeneficiary.yearofbirth} 
                                            onChange={this.handleChangeYearOfBirth} 
                                            disabled={this.state.disabled}
                                        />
                                        {institutionPrenests && <div>
                                        <label 
                                            for="institution"
                                            className={`form-label ${this.state.validation.institution ? "" : "text-danger"}`}
                                        >
                                            Учреждение:
                                        </label>
                                         <div
                                            className={
                                                this.state.validation.institution
                                                ? "" : "border border-danger rounded"
                                            }
                                        >
                                            <Select options= {this.state.instituteOptions} 
                                                    id="institution" 
                                                    onChange={this.handleChangeInstitution}
                                                    placeholder={this.state.currentBeneficiary.institution}  
                                                    isDisabled={this.state.disabled}  
                                                    />
                                        </div>        
                                        </div>        
                                        }       
                                         <div className="mt-4 d-flex justify-content-end">
                                            {!this.state.disabled &&
                                            <button 
                                                type="submit" 
                                                className="btn btn-primary" 
                                                onClick={this.save}
                                                disabled = {!this.state.isDraft || !this.state.validation.isValid}
                                            >
                                                Сохранить
                                            </button>
                                            }
                                            {this.state.saved && (
                                                <span className="badge text-bg-success">
                                                    Данные сохранены
                                                </span>
                                            )}
                                        </div>        
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 mt-4 mt-lg-0">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Действия</h6>
                                {this.state.currentBeneficiary.id && (
                                    <div>
                                        <button 
                                            class="btn btn-outline-primary w-100 mb-2" 
                                            onClick={()=>{this.openEvents()}}>События
                                        </button>             
                                        <button 
                                            class="btn btn-outline-primary w-100 mb-2" 
                                            onClick={()=>{this.openRefs()}}>Ссылки
                                        </button> 
                                         {["admin", "manager"].includes(this.state.role) &&
                                            <button
                                                className="btn btn-outline-primary w-100 mb-2"
                                                onClick={() => { this.delete(); }}
                                            >
                                                Удалить
                                            </button>
                                        }

                                    </div>
                                )}
                                {!this.state.currentBeneficiary.id && (
                                    <p className="text-muted mb-0">
                                        Дополнительные действия станут доступны после сохранения записи.
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        )
    }

}


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/beneficiary.js